(() => {
  /**
     * https://raygun.com/documentation/language-guides/javascript/crash-reporting/troubleshooting/
     */
  App.sendErrorToRaygun = (() => (
    function sendErrorToRaygun(err) {
      if (err) {
        try {
          // Save err if it's a plain string
          let msg = err;
          if (err instanceof Error) {
            // Runtime errors occur
            msg = JSON.stringify({
              name: err.name || '',
              message: err.message || '',
              stack: err.stack || '',
            });
          } else if (typeof err.promise === 'function') {
            // jQuery.ajax / await request failed
            msg = JSON.stringify({
              readyState: err?.readyState || err?.readyState === 0 ? err.readyState : '',
              status: err?.status || err?.status === 0 ? err.readyState : '',
              statusText: err?.statusText || '',
              responseText: err?.responseText || '',
              responseJSON: err?.responseJSON || '',
            });
          } else if (typeof err === 'object') {
            // Some other error object
            msg = JSON.stringify(err);
          }
          throw new Error(msg);
        } catch (e) {
          if (typeof window.Raygun !== 'undefined') {
            window.Raygun.send(e);
          }
        }
      }
    }
  ))();
})();
